import { render, staticRenderFns } from "./PatientBanner.vue?vue&type=template&id=0c3a5f69&scoped=true"
import script from "./PatientBanner.vue?vue&type=script&lang=js"
export * from "./PatientBanner.vue?vue&type=script&lang=js"
import style0 from "./PatientBanner.vue?vue&type=style&index=0&id=0c3a5f69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a5f69",
  null
  
)

export default component.exports